/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import classnames from 'classnames'
import { constructPageLink } from '@helpers/LinkHelper'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import './NavLinkBlock.module.scss'
import { supportsWebp } from '../../../helpers/webp'
const NavLinkBlock = ({ linkBox, simple = false }) => {
  const [format, setFormat] = useState('jpg')
  supportsWebp((isSupported) => {
    if (isSupported) {
      setFormat('webp')
    }
  })
  var imageSrc = R.path(['image', 'resize', 'src'], linkBox)
  if (!imageSrc.includes('progressive')) {
    imageSrc = imageSrc + `&fm=${format}`
  }
  const title = R.prop('title', linkBox)
  const link = R.path(['link', 'slug'], linkBox)
  const templateType = R.path(['link', 'template', 0, '__typename'], linkBox)
  const category = R.path(['link', 'template', 0, 'category'], linkBox)
  const description = R.path(['description', 'description'], linkBox)

  return (
    <div styleName={classnames('brochureWrapper', { simple })}>
      <div styleName={classnames('coverImage', { simple })}>
        <img alt={title.replace('™', '')} data-src={imageSrc} className='lazyload' />
      </div>
      <div styleName='infoWrapper'>
        <Link to={`${constructPageLink(link, templateType, category)}`}>
          {title && <h3 styleName={classnames('heading', { simple })}>{title}</h3>}
          <div>{description}</div>
        </Link>
      </div>
    </div>
  )
}

NavLinkBlock.propTypes = {
  simple: PropTypes.bool
}

export default NavLinkBlock



// WEBPACK FOOTER //
// ./src/components/PrimaryNavigation/NavLinkBlock/NavLinkBlock.js